<template>
<div class="main__container main__container--welcome">
  <div class="welcome">
    <span class="terms_policy pc_terms_policy">
      <a class="footer__link terms_policy_links" :href="$t('terms_url')" target="_blank">{{$t('terms')}}</a>
      {{" | "}}
      <a class="footer__link terms_policy_links" :href="$t('private_policy_url')" target="_blank">{{$t('private_policy')}}</a>
    </span>
    <div class="welcome__container" id="welcome__container">
      <header class="welcome__header">
        <h1 class="welcome__title">{{$t("login")}}</h1>
      </header>
        <login-form 
          :data_wmid="data_wmid"
          :status="status"
          @silent_login_success="silent_login_success"
          @change_status="change_status"
          @onload_page="onload_page"></login-form>

      <span class="terms_policy mobile_terms_policy">
        <a class="footer__link" :href="$t('terms_url')" target="_blank">{{$t('terms')}}</a>
        {{" | "}}
        <a class="footer__link" :href="$t('private_policy_url')" target="_blank">{{$t('private_policy')}}</a>
      </span>
    </div>
  </div>
</div>
</template>
<script>
import LoginForm from "./login_forms/LoginForm.vue";
import {loadWM} from '../helpers/LoadWM.js';
import {getCookie} from '../helpers/CookiesHelper'
export default {
  name: "LoginPage",
  components: {
    LoginForm,
  },
  emits: ['onload_page', 'change_status', 'silent_login_success'],
  props: {
    data_wmid: String,
    status: String
  },
  data() {
    return {
      currentTab: "login-form",
      lang: 'ru',
      error: null,
      noredirect: false,
      redirect: ""
    };
  },
  computed: {
    isLoginCurrentTab() {
      return this.currentTab === "login-form";
    },
  },
  methods: {
    silent_login_success(){
      this.$emit('silent_login_success')
    },
    change_status(val){
      this.$emit('change_status', val)
    },
    onload_page(){
      this.$emit('onload_page')
    },
    setSelectedComponent(tab) {
      this.currentTab = tab;
    },
    toggleCurrentTab() {
      if (this.currentTab === "login-form")
        this.currentTab = "signup-form";
      else
        this.currentTab = "login-form";
    },
    async loadUser(){
      // const isLogged = getCookie('isLogged')
      // console.log('isLogged', isLogged)
      // if(!isLogged){
      //   setCookie('isLogged', true)
      //   this.$router.push('about')
      // }

      try {
        await this.$store.dispatch('loadUser')
        this.email = this.$store.getters['user'].Email
        // loadWM(this.email.substr(0, 12), this.lang)
        if(!this.noredirect)
          this.$router.push('mail')
        return
      } catch (err) {
        // this.$emit('onload_page')
        this.error = err.message || "smth went wrong";
        setTimeout(()=>{
          this.error = null       
        }, 4000)
      }
      try{
        const resp = await this.$store.dispatch('getRid')
        if(resp) loadWM('', this.lang, resp, true)
      } catch (err) {
        this.error = err.message || "smth went wrong";
        setTimeout(()=>{
          this.error = null       
        }, 4000)
      }


    },
  },
  created(){
    const cookies_lang = getCookie('lang')
    if(this.$route.query.lang)
      this.lang = this.$route.query.lang
    else if(cookies_lang)
      this.lang = cookies_lang
    else if(navigator.language || navigator.userLanguage)
      this.lang = (navigator.language || navigator.userLanguage || '').substr(0,2);  
    else
      this.lang = process.env.VUE_APP_I18N_LOCALE
    const newquery = Object.assign({}, this.$route.query);
    const lang = this.$store.getters['getLanguage']
    if(lang){
      this.lang = lang
      newquery['lang'] = lang
      this.$router.push({query: {...newquery}});
    }
    this.$i18n.locale = this.lang
    const noredirect = this.$route.query.noredirect
    if(noredirect){
      const newquery = Object.assign({}, this.$route.query);
      this.noredirect = noredirect
      this.$emit('onload_page')
      this.$emit('change_status', 'failed')
      delete newquery['noredirect']
      this.$router.push({query: {...newquery}});
    }
    this.loadUser()
    // loadWM('', this.lang)
  }
};
</script>
<style scoped>
/*.main__container--welcome {
  height: 100vh;
}*/

.terms_policy{
  font-family: 'Manrope';
  font-size: 12px;
  line-height: 20px;
  font-weight: 600;
  font-style: normal;
  color: #BABCBF;
  position: relative;
  height: 24px;
  top: 8px;
}
.terms_policy_links:hover{
  color: rgb(33, 37, 41);
}
.pc_terms_policy{
  display: none;
}
@media (min-width: 768px) {
  .pc_terms_policy{
    top: 443px;
    margin-left: 64px;
    display: inline;
  }
  .mobile_terms_policy{
    display: none;
  }
}
</style>
